import { DataTable } from '../DataTable';
import { ValueCell } from './ValueCell';
import type { SimpleDataTableProps } from './types';

/**
 * A compact two-column table that renders a single record as rows of
 * **Label** (left, row header) and **Value** (right).
 */
export const SimpleDataTable = <TData extends Record<string, any>>({
	data,
	columns,
}: SimpleDataTableProps<TData>) => (
	<DataTable responsive>
		<tbody>
			{columns.map((column) => (
				<tr key={column.id}>
					<td className="sm:w-1/2">{column.label}</td>
					<ValueCell
						column={column}
						data={data}
					/>
				</tr>
			))}
		</tbody>
	</DataTable>
);
